var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#FDF3E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_37282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5189 18.6156H28.5352V22.5831H30.5189V18.6156Z",
    fill: "#BAE0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8491 22.9137H28.2041V18.285H30.8491V22.9137ZM28.8654 22.2525H30.1879V18.9462H28.8654V22.2525Z",
    fill: "#5E9C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5023 15.9706H30.5186V22.5831H32.5023V15.9706Z",
    fill: "#8BB7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.833 22.9137H30.188V15.64H32.833V22.9137ZM30.8492 22.2525H32.1717V16.3012H30.8492V22.2525Z",
    fill: "#4E7AB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4862 17.2931H32.5024V22.5831H34.4862V17.2931Z",
    fill: "#F78F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8169 22.9137H32.1719V16.9625H34.8169V22.9137ZM32.8331 22.2525H34.1556V17.6237H32.8331V22.2525Z",
    fill: "#C74343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6001 19.5017H17.9551V22.1116H20.6001V19.5017Z",
    fill: "#B0C1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9308 22.4423H17.6245V19.1711H20.9308V22.4423ZM18.2858 21.781H20.2695V19.8323H18.2858V21.781Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.253 21.5912H16.3018V22.2525H22.253V21.5912Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.89 12.0031H12.665V19.9381H25.89V12.0031Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2207 20.2687H12.3345V11.6725H26.2207V20.2687ZM12.9957 19.6075H25.5595V12.3337H12.9957V19.6075Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8898 23.9056H13.9873V27.2119H25.8898V23.9056Z",
    fill: "#DBB065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2205 27.5425H13.6567V23.575H26.2205V27.5425ZM14.318 26.8812H25.5592V24.2362H14.318V26.8812Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4864 23.9056H25.8901V35.8081H34.4864V23.9056Z",
    fill: "#F5CE85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8171 36.1387H25.5596V23.575H34.8171V36.1387ZM26.2208 35.4775H34.1558V24.2362H26.2208V35.4775Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8085 22.5831H11.3423V23.9056H35.8085V22.5831Z",
    fill: "#F5CE85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1392 24.2362H11.0117V22.2525H36.1392V24.2362ZM11.673 23.575H35.478V22.9137H11.673V23.575Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.665 18.9462V19.9381H25.89V18.9462H12.665Z",
    fill: "#66798F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9875 23.9056H12.665V35.8081H13.9875V23.9056Z",
    fill: "#F5CE85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3182 36.1387H12.3345V23.575H14.3182V36.1387ZM12.9957 35.4775H13.657V24.2362H12.9957V35.4775Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5107 32.5019H28.8657V33.1631H31.5107V32.5019Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5107 26.5506H28.8657V27.2118H31.5107V26.5506Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4864 29.5262H25.8901V30.1875H34.4864V29.5262Z",
    fill: "#967A44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_37282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.45,
    height: 26.45,
    fill: "white",
    transform: "translate(10.3506 10.35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainOffice);
export default __webpack_public_path__ + "static/media/main_office.e7b998ad.svg";
export { ForwardRef as ReactComponent };